import { formatPartnerMoneyFromMicroUnits } from '../../../shared/lib/money.js';

function formatDate(value) {
  const raw = String(value || '').trim();
  if (!raw) return '-';
  const date = new Date(raw);
  if (Number.isNaN(date.getTime())) return raw;
  return date.toLocaleString();
}

export function buildPartnersTableModel(dtoRows) {
  return dtoRows.map((row) => ({
    key: row.key,
    uid: row.uid,
    profileUid: row.profileUid,
    profileName: row.profileName,
    status: row.status,
    referralCode: row.referralCode,
    commissionPlanUid: row.commissionPlanUid,
    commissionPlanName: row.commissionPlanName,
    walletBalanceFormatted: formatPartnerMoneyFromMicroUnits(row.walletBalanceMicro, row.walletCurrency),
    createdAt: formatDate(row.created),
  }));
}
